export default "__VITE_ASSET__uelbhFjW__"